// Models
import { IExerciseData } from 'storage/exercise/models'
import {
  IFormInputs,
  IModelInput,
  IWorkoutSetInput,
  TSetSpecialSet,
  TSpecialSetInput,
} from 'models'

// React
import { FC, useContext, useEffect } from 'react'

// Libraries
import { ThemeContext } from 'styled-components'
import { useFormContext } from 'react-hook-form'

// Misc
import useMediaQuery from 'hooks/useMediaQuery'

// Components
import Desktop from './desktop'
import Mobile from './mobile'

type Props = {
  changePage?: (page: string) => void
  formIndex: number
  onEditSpecialSet?: (workoutSet: TSpecialSetInput) => void
  openExerciseGifModal: (exercise: IExerciseData) => void
  removeExerciseFromWorkoutSet: (
    modelId: string,
    workoutSetId: string,
    exerciseIndex: number,
  ) => void
  removeWorkoutSet: (modelId: string, workoutSetId: string) => void
  replicateWorkoutSetFields?: (modelId: string, set: IWorkoutSetInput) => void
  selectedModelIndex?: number
  setSpecialSet: TSetSpecialSet
  specialSet?: TSpecialSetInput
  stateModels?: IModelInput[]
}

const WorkoutSets: FC<Props> = ({
  replicateWorkoutSetFields,
  changePage,
  formIndex,
  onEditSpecialSet,
  openExerciseGifModal,
  removeExerciseFromWorkoutSet,
  removeWorkoutSet,
  selectedModelIndex,
  setSpecialSet,
  specialSet,
  stateModels,
}) => {
  const theme = useContext(ThemeContext)
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.desktop}px)`)

  const { setValue } = useFormContext<IFormInputs>()

  const workoutSetsPros = {
    replicateWorkoutSetFields,
    changePage,
    formIndex,
    onEditSpecialSet,
    openExerciseGifModal,
    removeExerciseFromWorkoutSet,
    removeWorkoutSet,
    selectedModelIndex,
    setSpecialSet,
    specialSet,
    stateModels,
  }

  useEffect(() => {
    stateModels?.map((stateModel, modelIndex) => {
      setValue(`models.${modelIndex}.name`, stateModel.name)

      Object.values(stateModel.workout_set)?.forEach((stateSet) => {
        if (stateSet.type !== 'normal') {
          setValue(`models.${modelIndex}.workout_set.${stateSet.id}`, {
            ...stateSet,
            quantity: stateSet.quantity || '',
            interval: stateSet?.interval || '',
            exercises: stateSet.exercises.map((setToExercise) => {
              return {
                ...setToExercise,
                weight: setToExercise?.weight || '',
                repetitions: setToExercise.repetitions || '',
                cadence: setToExercise?.cadence || '',
              }
            }),
          })
        }
      })
    })
  }, [setValue, stateModels])

  return isDesktop ? (
    <Desktop {...workoutSetsPros} />
  ) : (
    <Mobile {...workoutSetsPros} />
  )
}

export default WorkoutSets
